import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const links = [
  ['/', 'Home'],
  ['/services', 'Services'],
  ['/demos', 'Demos'],
  ['/about', 'About Us'],
  ['/contact', 'Contact']
];

function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const update = () => setScrolled(window.scrollY > 40);
    update();
    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, []);

  return (
    <header className={`header ${scrolled ? 'header-scrolled' : ''}`}>
      <Link
        to="/"
        className="brand"
        aria-label="Duran Media home"
        onClick={() => setOpen(false)}
      >
        <span className="brand-mark" aria-hidden="true">
          <i>D</i>
        </span>
        <span aria-hidden="true">
          DURAN <b>MEDIA</b>
        </span>
      </Link>

      <button
        className="menu-button"
        type="button"
        aria-label={open ? 'Close navigation menu' : 'Open navigation menu'}
        aria-expanded={open}
        aria-controls="primary-navigation"
        onClick={() => setOpen(!open)}
      >
        <SafeIcon
          name={open ? 'X' : 'Menu'}
          aria-hidden="true"
          focusable="false"
        />
      </button>

      <nav
        id="primary-navigation"
        className={open ? 'nav open' : 'nav'}
        aria-label="Primary navigation"
      >
        {links.map(([to, label]) => (
          <NavLink key={to} to={to} onClick={() => setOpen(false)}>
            <span>{label}</span>
          </NavLink>
        ))}
        <Link
          to="/contact"
          className="nav-cta"
          onClick={() => setOpen(false)}
        >
          Start a project
          <SafeIcon
            name="ArrowUpRight"
            aria-hidden="true"
            focusable="false"
          />
        </Link>
      </nav>
    </header>
  );
}

export default Header;